/* eslint-disable max-len */

import React from "react"

import BaseSvgIcon from "./Base"

const Delete = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3334 4H11V2.33333C11 2.14924 10.8508 2 10.6667 2H5.33337C5.14928 2 5.00004 2.14924 5.00004 2.33333V4H2.66671C2.48261 4 2.33337 4.14924 2.33337 4.33333C2.33337 4.51743 2.48261 4.66667 2.66671 4.66667H3.66671V14.3333C3.66671 14.5174 3.81595 14.6667 4.00004 14.6667H12C12.1841 14.6667 12.3334 14.5174 12.3334 14.3333V4.66667H13.3334C13.5175 4.66667 13.6667 4.51743 13.6667 4.33333C13.6667 4.14924 13.5175 4 13.3334 4ZM5.66671 2.66667H10.3334V4H5.66671V2.66667ZM4.33337 14H11.6667V4.66667H4.33337V14ZM6.66671 6C6.48261 6 6.33337 6.14924 6.33337 6.33333V11.6667C6.33337 11.8508 6.48261 12 6.66671 12C6.8508 12 7.00004 11.8508 7.00004 11.6667V6.33333C7.00004 6.14924 6.8508 6 6.66671 6ZM9.00004 6.33333C9.00004 6.14924 9.14928 6 9.33337 6C9.51747 6 9.66671 6.14924 9.66671 6.33333V11.6667C9.66671 11.8508 9.51747 12 9.33337 12C9.14928 12 9.00004 11.8508 9.00004 11.6667V6.33333Z"
    />
  </BaseSvgIcon>
)

export default Delete
